module.exports = __webpack_public_path__ + "static/media/i6.1b10c93f.jpg";